import { PatientsTagsEnum } from '../helpers/types'

export const DEFAULT_MODAL_WIDTH = 1000
export const SMALL_MODAL_WIDTH = 700

export const ICURE_CLOUD_URL = 'https://nightly.icure.cloud'
export const MSG_GW_URL = 'https://msg-gw.icure.cloud'
export const SPEC_ID = process.env.REACT_APP_EXTERNAL_SERVICES_SPEC_ID
export const PROCESS_ID = process.env.REACT_APP_EMAIL_AUTHENTICATION_PROCESS_ID

export const DATE_FORMAT = 'dd.MM.yyyy'
export const DATE_FORMAT_TO_DISPLAY = 'DD.MM.YYYY'

export const PREVENTI_FORM_TEMPLATE_GUID = 'b4e7c2a1-8f3d-4e6b-9c1a-2d5f7e8a0b3c'
export const PREVENTI_FORM_TEMPLATE_SPECIALTY_CODE = 'preventi'

export const emailsWorkflow = [
  {
    emailDescription: 'Welcome emaintil',
    tag: PatientsTagsEnum.UNINVITED,
    nextTag: PatientsTagsEnum.WELCOMED,
    templates: [
      { name: '#1 Welcome email / FR', templateId: 'a19d6f93-70ee-4c60-88ca-1a66cd9404e9', language: 'FR' },
      { name: '#1 Welcome email / NL', templateId: 'c8854ee0-c032-477d-8137-13837d90bdd5', language: 'NL' },
    ],
  },
  {
    emailDescription: 'Questionnaire email',
    tag: PatientsTagsEnum.WELCOMED,
    nextTag: PatientsTagsEnum.QUESTIONNAIRE_SENT,
    templates: [
      { name: '#2 Answer the questionnaire / FR', templateId: 'dbe1ab37-20fa-4446-99c5-06caf7737c9d', language: 'FR' },
      { name: '#2 Answer the questionnaire / NL', templateId: '25dc2e56-5377-4c1a-b630-6b32dfc1d62f', language: 'NL' },
    ],
  },
  {
    emailDescription: 'Reminder: Answer the questionnaire',
    tag: PatientsTagsEnum.QUESTIONNAIRE_SENT,
    nextTag: PatientsTagsEnum.QUESTIONNAIRE_SENT,
    templates: [
      { name: '#2.1 Reminder: Answer the questionnaire / FR', templateId: '91ff2f6c-ea2c-409c-875b-cd2919caaf40', language: 'FR' },
      { name: '#2.1 Reminder: Answer the questionnaire / NL', templateId: '99b08d32-32e4-4bb6-9073-1f0a63d88533', language: 'NL' },
    ],
  },
  {
    emailDescription: 'Nurse appointment booking',
    tag: PatientsTagsEnum.RESPONSE_RECEIVED,
    nextTag: PatientsTagsEnum.NURSE_APPOINTMENT_REQUEST_SENT,
    templates: [
      { name: '#3 Nurse appointment booking / FR', templateId: '969f9510-6b5e-4e43-a1d5-196d9e06be42', language: 'FR' },
      { name: '#3 Nurse appointment booking / NL', templateId: '323be9c3-44bf-4a6e-87f8-6254f9edbfe5', language: 'NL' },
    ],
  },
  {
    emailDescription: 'Reminder: Nurse appointment booking',
    tag: PatientsTagsEnum.NURSE_APPOINTMENT_REQUEST_SENT,
    nextTag: PatientsTagsEnum.NURSE_APPOINTMENT_REQUEST_SENT,
    templates: [
      { name: '#3.1 Reminder: Nurse appointment booking / FR', templateId: '54d556ad-0e3a-4261-a63f-33746fc44099', language: 'FR' },
      { name: '#3.1 Reminder: Nurse appointment booking / NL', templateId: '3eba9c99-569d-4cb5-b693-f3cd22df7f2d', language: 'NL' },
    ],
  },
  {
    emailDescription: 'Doctor appointment booking',
    tag: PatientsTagsEnum.NURSE_APPOINTMENT_TAKEN,
    nextTag: PatientsTagsEnum.DOCTOR_APPOINTMENT_REQUEST_SENT,
    templates: [
      { name: "#4 Making a doctor's appointment / FR", templateId: '883134ed-79e0-4147-b5d7-aeb9f86f4452', language: 'FR' },
      { name: "#4 Making a doctor's appointment / NL", templateId: '3a396d6c-d6ce-4fea-b02d-bc471d1ae657', language: 'NL' },
    ],
  },
  {
    emailDescription: 'Access to health results',
    tag: PatientsTagsEnum.DOCTOR_APPOINTMENT_TAKEN,
    nextTag: PatientsTagsEnum.REPORT_SENT,
    templates: [
      { name: '#5 Health results are available / FR', templateId: '632c988e-e75a-4ca0-a38a-f3a88b377ad6', language: 'FR' },
      { name: '#5 Health results are available / NL', templateId: '29d67b5f-865b-4a28-b391-e980cd0791c8', language: 'NL' },
    ],
  },
]
